import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import { UserAddOutlined } from "@ant-design/icons";

import { routeNewTaxpayer } from "routes/pages";
import { TaxpayersTable } from 'components';

export function Taxpayers({partnerId}: {partnerId: number}): JSX.Element {
  const itemsPerPage = 50;

  return (
    <>
      {/* <Row justify="end" style={{ marginBottom: "0.75rem" }}>
        <Col>
          <Link to={routeNewTaxpayer()} className="ant-btn ant-btn-link ant-btn-lg">
            <UserAddOutlined /> Crear nuevo contribuyente
          </Link>
        </Col>
      </Row> */}
      <TaxpayersTable itemsPerPage={itemsPerPage} partnerId={partnerId} />
    </>
  );
}
